import { createContext, useContext, type PropsWithChildren } from 'react';
import type { PlatformAdapter } from '@petrhythm/core';
import { setActivePlatformAdapter, webAdapter } from './platform.js';

const PlatformContext = createContext<PlatformAdapter>(webAdapter);

export function PlatformProvider({ adapter, children }: PropsWithChildren<{ adapter: PlatformAdapter }>) {
  setActivePlatformAdapter(adapter);
  return <PlatformContext.Provider value={adapter}>{children}</PlatformContext.Provider>;
}

export function usePlatform(): PlatformAdapter {
  return useContext(PlatformContext);
}
